export default "__VITE_ASSET__qXFHcn0b__"